module.exports = __webpack_public_path__ + "3squared_logo.png";